import {FILE_TYPE, SOURCE} from "../../../constants/file-image-types";

export const FOLDERS_ROUTE_NAME = 'file.tab.folder'

export const VIEW_TYPE = {
    GRID: 'grid',
    LIST: 'list'
}

export const TABS = {
    PRODUCTS: 'products',
    STOCK_IMAGES: 'stock-images',
    BACKGROUND: 'background',
    FILES: 'files',
    AI_STUDIO: 'ai-studio',
    THEMES: 'themes',
    WALMART_ASSETS: 'walmart-assets',
    BYNDER_ASSETS: 'bynder-assets',
    SALSIFY_ASSETS: 'salsify-assets',
    SALSIFY_PRODUCTS: 'salsify-products',
    VIDEO: 'video',
    LAYOUTS: 'layouts',
    BRIEF: 'brief',
    STOCK: 'stock',
    ITS_RAPID_STOCK: 'its-rapid-stock',
    PIXABAY_STOCK: 'pixabay-stock',
    BOX_ASSETS: 'box-assets',
}

export const TAB_SOURCE_MAP = {
    [TABS.FILES]: SOURCE.FOLDER,
    [TABS.PRODUCTS]: SOURCE.PRODUCT,
    [TABS.STOCK_IMAGES]: SOURCE.STOCK,
    [TABS.BACKGROUND]: SOURCE.BACKGROUND,
    [TABS.WALMART_ASSETS]: SOURCE.WALMART_ASSETS,
    [TABS.BYNDER_ASSETS]: SOURCE.BYNDER_ASSETS,
    [TABS.SALSIFY_ASSETS]: SOURCE.SALSIFY_ASSETS,
    [TABS.BOX_ASSETS]: SOURCE.BOX_ASSETS
}

export const API_TABS = [TABS.BYNDER_ASSETS, TABS.SALSIFY_ASSETS];

export const FILE_BROWSER_FILTER_QUERY_KEYS = [
    'file_type',
    'uploaded_by',
    'uploaded_from',
    'uploaded_to',
    'min_width',
    'max_width',
    'min_height',
    'max_height',
    'min_size',
    'max_size',
];

export const MODALS = {
    SETTINGS: 'SETTINGS',
    CREATE_LINK: 'CREATE_LINK',
    DELETE_SELECTED: 'DELETE_SELECTED',
    SHARE: 'SHARE',
    UPLOAD: 'UPLOAD',
    FILE_EXISTS: 'FILE_EXISTS',
    DELETE_ITEM: 'DELETE_ITEM',
    RENAME: 'RENAME',
    CUSTOMIZE_FOLDER: 'CUSTOMIZE_FOLDER',
    BRIEF_FOLDER_RENAME: 'BRIEF_FOLDER_RENAME',
    COMPRESS_LOADER: 'COMPRESS_LOADER',
    CONVERT: 'CONVERT',
    RESIZE: 'RESIZE',
    CROP: 'CROP',
    REMOVE_BACKGROUND: 'REMOVE_BACKGROUND',
    PREVIEW_FILE: 'PREVIEW_FILE',
    UPLOAD_TO_TARGET: 'UPLOAD_TO_TARGET',
    TAGS_EDITOR: 'TAGS_EDITOR',
    PREVIEW_IMAGE: 'PREVIEW_IMAGE',
    PDF_FILE: 'PDF_FILE_TYPE',
    SVG_EDITOR: 'SVG_EDITOR',
    FILE_INFO: 'FILE_INFO',
    UPLOAD_PRODUCT_FILES: 'UPLOAD_PRODUCT_FILES',
    FOLDER_SETTINGS: 'FOLDER_SETTINGS',
    MERGE_PPTX: 'MERGE_PPTX',
    IMPORT_FROM_IMAGE: 'IMPORT_FROM_IMAGE',
    IMPORT_SPREADSHEET: 'IMPORT_SPREADSHEET',
    PUBLISH_TO_PLATFORM: 'PUBLISH_TO_PLATFORM',
    SHARE_PROOF: 'SHARE_PROOF',
    SHARE_PROOF_VIDEO: 'SHARE_PROOF_VIDEO',
    IMPORT_TO_VIDEO: 'IMPORT_TO_VIDEO',
}

export const IMAGE_FILE_TYPES = ['png', 'jpg', 'webp', 'tiff', 'image', 'jpeg', 'bmp', 'gif', 'psd', 'avif', 'box_file', FILE_TYPE.EPS];
// Salsify/Stock put an extension in `type` ('jpg'); Files/Products use the 'image' token.
export const SCENE_IMAGE_TYPES = IMAGE_FILE_TYPES.filter(type => type !== FILE_TYPE.PSD);
export const VIDEO_FILE_TYPES = ['mp4', 'mov', 'avi', 'mpg', 'm4a', 'wmv', 'flv'];
export const PDF_FILE_TYPE = ['pdf'];
export const PSD_FILE_TYPE = ['psd'];
export const AUDIO_FILE_TYPES = [FILE_TYPE.MP3, FILE_TYPE.WAV];

// fileBrowserItemToFile() picks its branch by `item.type` and then checks the extension, so both
// have to match here: Files and Products call every image 'image', tiff and bmp included.
export const VIDEO_IMPORT_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'gif'];
export const VIDEO_IMPORT_VIDEO_EXTENSIONS = ['mp4', 'mov', 'webm'];

export const SIMPLE_IMAGE_TYPES = [
  FILE_TYPE.PNG,
  FILE_TYPE.JPG,
  FILE_TYPE.JPEG,
  FILE_TYPE.IMAGE,
  FILE_TYPE.TIFF,
  FILE_TYPE.TIF,
  FILE_TYPE.AVIF
]
